import { TabActive } from "../../../../types";
import {
  Budget,
  BudgetItemTypeEnum,
  HeaderOptions,
  initCategoryTotals,
  keysCategoryTotalsBRL,
  versionInfo,
} from "../../../../types/budget/budget";

export function defineTotals(
  activeCalcOption: HeaderOptions,
  activeBudget: Budget,
  supplierId: string,
  type: keyof typeof BudgetItemTypeEnum,
) {
  const calcTotalsSource = JSON.parse(JSON.stringify(initCategoryTotals));
  const calcTotalsCompare = JSON.parse(JSON.stringify(initCategoryTotals));

  if (activeCalcOption !== "budgetTotals") {

    for (const key of keysCategoryTotalsBRL) {
      calcTotalsSource[key as keyof typeof calcTotalsSource] =
        activeBudget?.budgetValuesTotal?.byCalculationType?.[
          activeCalcOption
        ][type]?.find(
          (el) => !!el.supplierId && el.supplierId === supplierId
        )?.[key] || { totalInBRL: 0, totalInCurrency: 0 };
    }
    return { calcTotalsSource, calcTotalsCompare };

  }
}
